<script setup lang="ts">
import { ref, PropType } from "vue";
import { Participant, Project } from "../../../types/PersologOnlineTypes";
import ParticipantConfig from "../participant-configuration/ParticipantConfig.vue";

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    project: {
        type: Object as () => Project,
        required: true,
    },
    participants: {
        type: Array as PropType<Participant[]>,
        required: true,
    },
});

const participants = ref<Participant[]>(props.participants);
const participantConfigRef = ref<InstanceType<typeof ParticipantConfig> | null>(null);

const validate = () => {
    emit("update:participants", participants);
    emit("valid", true);
    return true;
};

function handleParticipantsUpdate(createdParticipants: Participant[]) {
    participants.value = createdParticipants;
    emit("update:participants", participants);
}

defineExpose({
    addParticipant: () => participantConfigRef.value?.addParticipant(),
    validate,
});

const emit = defineEmits(["valid", "update:participants"]);
</script>

<template>
    <ParticipantConfig
        ref="participantConfigRef"
        :id="id"
        :project="project"
        :participants-to-add="participants"
        @update:participants="handleParticipantsUpdate"
    />
</template>
